export default function booleanToHumanString(value?: boolean): string {
  if (value) {
    return 'Yes'
  }
  return 'No'
}
